import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  mainDiv: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4,1fr)',
    alignItems: 'center',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: 35
    }
  },

  uploadBox: {
    height: 120,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center'
  },
  button: {
    marginTop: 30,
    [theme.breakpoints.down('sm')]: {
      marginTop: 10
    }
  }
}))
export default useStyles
